function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// 菜单组件统一添加 el-icon- 前缀，兼容后端带前缀的配置和旧菜单缓存。
var businessIcons = {
  '/artResource': 'collection',
  '/aiGeneration': 'cpu',
  '/qualification': 's-check',
  '/expertReview': 'chat-dot-square'
};

// 明确不需要图标的菜单（如二级模块，防止本地旧缓存残留）
var removeIcons = ['/artEvent'];
export function normalizeMenuIcons(menus) {
  return (menus || []).map(function (menu) {
    var icon = businessIcons[menu.path] || (menu.icon || '').replace(/^(el-icon-)+/, '');
    if (removeIcons.includes(menu.path)) {
      icon = '';
    }
    return _objectSpread(_objectSpread({}, menu), {}, {
      icon: icon
    }, menu.children ? {
      children: normalizeMenuIcons(menu.children)
    } : {});
  });
}